import React from 'react';
//import { useState } from 'react'
import { get } from 'lodash';
import { useSelector } from 'react-redux';
// Material Imports
import {
  List,
  ListSubheader,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar
} from '@material-ui/core';
// Components
import { dateFormat } from '../../../api/dateFormat';

//assets

import Email from '../../../assets/profileIcon/email.svg';
import Phone from '../../../assets/profileIcon/phone.svg';
import Calendar from '../../../assets/profileIcon/calendar.svg';
import Education from '../../../assets/profileIcon/education.svg';
import MapMarker from '../../../assets/profileIcon/map-marker.svg';
import BatchName from '../../../assets/profileIcon/batch-name.svg';
import Phase from '../../../assets/profileIcon/phase.svg';
import CourseName from '../../../assets/profileIcon/course-name.svg';
import CampusAddress from '../../../assets/profileIcon/campus-address.svg';
import CampusName from '../../../assets/profileIcon/campus-name.svg';
import CourseCode from '../../../assets/profileIcon/course-code.svg';

//style
import './styles.scss';

const MyProfilePopup = () => {
  //state
  //const [imageLoading, setImageLoading] = useState(true);
  //redux
  const profile = useSelector(state =>
    get(state, 'dashboardReducer.profileData', '')
  );
  const ProfilePhoto = get(profile, 'profile[0].StudentPic', '');
  const FullName = get(profile, 'profile[0].FirstName', '');
  const personal = {
    ApplicationFormNo: get(profile, 'profile[0].EnrolmentNo', ''),
    Email: get(profile, 'profile[0].EmailiD', ''),
    Mobile: get(profile, 'profile[0].MobileNo', ''),
    DateOfBirth: get(profile, 'profile[0].DOB', '')
      ? dateFormat(get(profile, 'profile[0].DOB', ''))
      : '',
    CurrentSchool: get(profile, 'profile[0].CurrentSchool', '')
  };
  const batch = {
    BatchName: get(profile, 'profile[0].BatchName', ''),
    Phase: get(profile, 'profile[0].SubClassTitle', ''),
    CourseName: get(profile, 'profile[0].CourseName', ''),
    CourseCode: get(profile, 'profile[0].CourseCode', ''),
    CampusName: get(profile, 'profile[0].CampusName', ''),
    CampusAddress: get(profile, 'profile[0].CampusAddress', '')
  };
  const contact = {
    MobileNo: get(profile, 'profile[0].MobileNo', ''),
    PhoneNo: get(profile, 'profile[0].ContactNo', ''),
    AddressLine1: get(profile, 'profile[0].AddressLine_1', ''),
    AddressLine2: get(profile, 'profile[0].AddressLine_2', ''),
    AddressLine3: get(profile, 'profile[0].AddressLine_3', ''),
    City: get(profile, 'profile[0].City', ''),
    Pincode: get(profile, 'profile[0].PinCode', '')
  };
  const No = contact.MobileNo
    ? contact.PhoneNo
      ? `${contact.MobileNo} | ${contact.PhoneNo}`
      : contact.MobileNo
    : contact.PhoneNo
    ? contact.PhoneNo
    : '';

  //functions
  //CORS Error
  /*
  const checkImageURL = (url) => {
    fetch(url, { origin: 'cors' })
      .then((res) => {
        if (res.status == 404) {
          setImageLoading(false);
        } else {
          setImageLoading(true);
        }
      })
      .catch((err) => {
        setImageLoading(false);
      });
  };*/

  const headerContent = () => {
    return (
      <div className="profile-header">
        <Avatar alt={FullName} src={ProfilePhoto} />
        <ListItemText
          primary={FullName}
          secondary={`Application No. ${personal.ApplicationFormNo}`}
        />
      </div>
    );
  };

  const bodyContent = () => {
    return (
      <div className="profile-list">
        <List
          subheader={
            <ListSubheader disableSticky={true}>PERSONAL DETAILS</ListSubheader>
          }
        >
          <ListItem>
            <ListItemIcon>
              <img src={Email} />
            </ListItemIcon>
            <ListItemText primary={personal.Email} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={Phone} />
            </ListItemIcon>
            <ListItemText primary={No} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={Calendar} />
            </ListItemIcon>
            <ListItemText primary={personal.DateOfBirth} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={Education} />
            </ListItemIcon>
            <ListItemText primary={personal.CurrentSchool} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={MapMarker} />
            </ListItemIcon>
            <ListItemText
              primary={
                contact.AddressLine1 +
                ' ' +
                contact.AddressLine2 +
                ' ' +
                contact.AddressLine3 +
                ' ' +
                contact.City +
                ' ' +
                contact.Pincode
              }
            />
          </ListItem>
        </List>
        <Divider className="profile-divider" />
        <List subheader={<ListSubheader>BATCH DETAILS</ListSubheader>}>
          <ListItem>
            <ListItemIcon>
              <img src={BatchName} />
            </ListItemIcon>
            <ListItemText primary={batch.BatchName} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={Phase} />
            </ListItemIcon>
            <ListItemText primary={batch.Phase} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={CourseName} />
            </ListItemIcon>
            <ListItemText primary={batch.CourseName} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={CourseCode} />
            </ListItemIcon>
            <ListItemText primary={batch.CourseCode} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={CampusName} />
            </ListItemIcon>
            <ListItemText primary={batch.CampusName} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <img src={CampusAddress} />
            </ListItemIcon>
            <ListItemText primary={batch.CampusAddress} />
          </ListItem>
        </List>
      </div>
    );
  };

  return (
    <React.Fragment>
      {headerContent()}
      {bodyContent()}
    </React.Fragment>
  );
};
export default MyProfilePopup;
